import { fetchFromApi } from "./fetchFromApi";
export async function tipsRequest(endpoint, body = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 90000);
  try {
    const response = await fetchFromApi(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      signal: controller.signal,
    });
    const result = await response.json();
    if (!response.ok || result?.success === false)
      throw new Error(result?.code || result?.message || "REQUEST_FAILED");
    return result;
  } finally {
    clearTimeout(timeout);
  }
}
export async function runTipsWorkflow({
  period,
  selection,
  customRange,
  onProgress = () => {},
  request = tipsRequest,
  shouldStop = () => false,
}) {
  onProgress({ phase: "check", current: 0, total: 1 });
  const prepared = await request("tips-prepare", {
    period,
    selection,
    customRange,
    offsetMinutes: new Date().getTimezoneOffset(),
  });
  const failures = [];
  const tips = [],
    bookmakers = new Map();
  let complete = 0,
    compileCalls = 0,
    marketRequests = 0,
    processed = 0;
  for (const [index, fixture] of prepared.fixtures.entries()) {
    if (shouldStop()) break;
    processed = index + 1;
    onProgress({
      phase: "prepare",
      current: index,
      total: prepared.fixtures.length,
    });
    try {
      const result = await request("tips-fixture", {
        fixtureId: fixture.id,
        selection: prepared.profile,
        period,
        customRange,
        offsetMinutes: new Date().getTimezoneOffset(),
      });
      tips.push(...result.tips);
      result.bookmakers.forEach((b) => bookmakers.set(b.id, b));
      complete++;
      compileCalls += result.metrics?.compileCalls || 0;
      marketRequests += result.metrics?.marketRequests || 0;
    } catch (e) {
      failures.push({ fixtureId: fixture.id, message: e.message });
    }
    onProgress({
      phase: "prepare",
      current: index + 1,
      total: prepared.fixtures.length,
    });
  }
  onProgress({
    phase: shouldStop() ? "stopped" : "done",
    current: processed,
    total: prepared.fixtures.length,
  });
  return {
    ...prepared,
    tips,
    bookmakers: [...bookmakers.values()],
    failures,
    complete,
    total: processed,
    requestedTotal: prepared.fixtures.length,
    compileCalls,
    marketRequests,
    evaluateCalls: 0,
    cancelled: shouldStop(),
  };
}
